import { Pipe, PipeTransform } from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
  name: 'keepHtml',
  pure: true,
})
export class KeepHtmlPipe implements PipeTransform {
  constructor(
    private sanitizer: DomSanitizer,
  ) {
  }

  transform(content: string | null | undefined): any {
    return content ? this.sanitizer.bypassSecurityTrustHtml(content) : null;
  }

}
